import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import "rxjs/add/operator/debounceTime";

// Classes.
import { EventListFilterConf, LevelPreset } from '../../classes/event-list-filter.conf';

// Services.
import { WaHelperService, IFilterComboComponent } from 'world-archery-lib';
import { EventsResultsFiltersService } from '../../services/events-results-filters.service';
import { map } from 'rxjs/operators';


@Component({
  selector: 'event-list-filter',
  templateUrl: './event-list-filter.component.html',
  styleUrls: ['./event-list-filter.component.scss']
})
export class EventListFilterComponent implements OnInit {

  constructor(public filter_service: EventsResultsFiltersService) {

  }

  ngOnInit() {
  }

  /**
   * A method for set level when a bubble is clicked
   *
   * @param {number} level
   * @param {string} name
   * @memberof EventListFilterComponent
   */
  setLevel(level: number, name: string) {
    (<IFilterComboComponent>(
      this.filter_service.filtersType[1].options
    )).options_selected_subject.next({ name: name, id: [] });
    this.filter_service.level_id.next({ id: [level] });
  }

  /**
   *
   * A method for check if a popular level is selected
   * @param {number} level
   * @returns
   * @memberof EventListFilterComponent
   */
  isLevel(level: number) {
    return this.filter_service.level_id.pipe(map(a => (a.id instanceof Array && a.id.length === 1 && a.id[0] === level) ? true : false))
  }
}
